import groupBy from 'lodash/groupBy';
import { types } from './types';



const INITIAL_STATE = {
  variables : {},
  permissions : {},
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.UPDATE_FORM_FIELD:
      return {
        ...state,
        [payload.group]: {
          ...state[payload.group],
          [payload.key]: payload.value,
        },
      };
    case types.UPDATE_ADMIN_FIELD:
        return {
          ...state,
          [payload.group]: {
            ...state[payload.group],
            [payload.key]: {
              ...state[payload.group][payload.key],
              value: payload.value,
            },
          },
        };
    case types.UPDATE_ADMIN_TABLE_FIELD:
        return {
          ...state,
          [payload.group]: {
            ...state[payload.group],
            [payload.parent_index]: {
              ...state[payload.group][payload.parent_index],
              value: state[payload.group][payload.parent_index].value.map((item, i) => {
                if (i === payload.index) {
                  return {
                    ...item,
                    [payload.key]: payload.value
                  };
                }
                return item;
              })
            },
          },
        };
    case types.LIST_APPLICATIONS_ADMIN.SUCCESS:
      const content = groupBy(payload.content, 'field');
      return {
        ...state,
        variables: payload.variables,
        activeTaskName: payload.activeTaskName,
        applStatus: payload.variables.applStatus,
      };
    case types.GET_FORM_DATA.SUCCESS:
      return {
        ...state,
        variables: payload.variables,
      };
    case types.GET_TASK_DATA.SUCCESS:
      return {
        ...state,
        task: {
          ...state.task,
          ...payload,
        },
      };
    case types.FETCH_PROCESS_SAYT.SUCCESS:
      return {
        ...state,
        sayt: {
          ...state.sayt,
          ...payload,
        },
      };
    case types.GET_ACTIONS_ADMIN.SUCCESS:
      return {
        ...state,
        permissions: {
          ...state.permissions,
          ...payload,
        },
      };
    case types.GET_PROCESS_VARIABLES_ADMIN.SUCCESS:
      return {
        ...state,
        processVariables: {
          ...state.processVariables,
          ...payload,
        },
      };
    case types.UPDATE_PROCESS_ADMIN.SUCCESS:
        return {
          ...state,
          submitting: false,
        };
    case types.GET_ALL_USERS_DATA_ADMIN.SUCCESS:
      return {
        ...state,
        allUsers: payload,
      };
    case types.GET_ALL_GROUPS_ADMIN.SUCCESS:
      return {
        ...state,
        allGroups: payload,
      };
    case types.GET_COUNTRY_LOCALS_ADMIN.SUCCESS:
      return {
        ...state,
        countryStrings: payload,
      };
    case types.UPDATE_LOCAL_ADMIN.SUCCESS: {
      const updatedLocals = state.countryStrings.map(local => 
          local.name === payload.name 
              ? { ...local, name: payload.name, localString: payload.localString }
              : local
      );
      // const newSelectedUser = {
      //     ...state.selectedUser,
      //     name: payload.name,
      //     localString: payload.localString,
      // };
  
      return {
          ...state,
          countryStrings: updatedLocals,
          // selectedUser: newSelectedUser,
      };
    }
    case types.GET_ALL_APP_CONFIGURATIONS_ADMIN.SUCCESS:
      return {
        ...state,
        appConfigs: payload,
      };
    case types.GET_SELECTED_APP_CONFIGURATION_ADMIN.SUCCESS:
      return {
        ...state,
        selectedConfig: payload,
      };
    case types.GET_USER_DATA_ADMIN.SUCCESS:
      return {
        ...state,
        selectedUser: payload,
      };
    case types.GET_GROUP_DATA_ADMIN.SUCCESS:
      return {
        ...state,
        selectedGroup: payload,
      };
    case types.CREATE_USER_ADMIN.SUCCESS:
      return {
        ...state,
        allUsers: [...state.allUsers, payload]
      }
    case types.CREATE_GROUP_ADMIN.SUCCESS:
      return {
        ...state,
        allGroups: [...state.allGroups, payload]
      }
    case types.UPDATE_USER_GROUP_ADMIN.SUCCESS: {
      const updatedUserGroup = payload.map(group => 
        ({ id: group, name: group, type: "assignment" })
      );
  
      return {
          ...state,
          selectedUser: {
              ...state.selectedUser,
              groups: updatedUserGroup
          }
      };
    }
    case types.CLEAR_USER_GROUPS.SUCCESS: {
      return {
          ...state,
          selectedUser: {
            ...state.selectedUser,
            groups: []
        }
      };
    }
    case types.UPDATE_USER_ADMIN.SUCCESS: {
      const updatedUsers = state.allUsers.map(user => 
          user.id === payload.id 
              ? { ...user, firstName: payload.firstName, lastName: payload.lastName, email: payload.email }
              : user
      );
      const newSelectedUser = {
          ...state.selectedUser,
          firstName: payload.firstName,
          lastName: payload.lastName,
          email: payload.email,
          info: payload.info,
      };
  
      return {
          ...state,
          allUsers: updatedUsers,
          selectedUser: newSelectedUser,
      };
    }
    case types.ADD_USER_INFO_ADMIN.SUCCESS: {
      return state;
    }
    case types.DELETE_USER_ADMIN.SUCCESS:
      return {
        ...state,
        allUsers: state.allUsers.filter(user => user.id !== payload)
      }
    case types.DELETE_GROUP_ADMIN.SUCCESS:
      return {
        ...state,
        allGroups: state.allGroups.filter(group => group.id !== payload)
      }
    default:
      return state;
  }
};

export default reducer;
